interface ClickableCharactersProps {
  text: string;
  onCharacterClick?: (character: string) => void;
  className?: string;
}

export function ClickableCharacters({
  text,
  onCharacterClick,
  className = "",
}: ClickableCharactersProps) {
  // If no click handler or single character, just render the text
  if (!onCharacterClick || text.length <= 1) {
    return <span className={className}>{text}</span>;
  }

  const characters = [...text];

  return (
    <span className={className}>
      {characters.map((char, index) => (
        <span
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            onCharacterClick(char);
          }}
          className="cursor-pointer hover:text-primary hover:underline underline-offset-4 transition-colors"
          title={`Look up "${char}"`}
        >
          {char}
        </span>
      ))}
    </span>
  );
}
